import React from "react"
import { useFormContext } from "react-hook-form"

import { OTHER_EXPENSES_ROLE } from "~/helpers/otherCosts"

import ExpensesTableRow from "../ExpensesTableRow"
import { useProjectBudgetFormContext } from "../ProjectBudgetFormProvider"
import { ProjectBudgetFormData } from "../formTypes"

const OtherExpensesRow = () => {
  const { watch, setValue } = useFormContext<ProjectBudgetFormData>()
  const formData = watch()

  const { expensesAllocationDifference, hasExpenses } =
    useProjectBudgetFormContext()

  // Find the "Other Expenses" role
  const expenseRole = formData.roles.find(
    (role) => role.id === OTHER_EXPENSES_ROLE.id,
  )
  if (!expenseRole) return null

  const value = expenseRole.estimatedMinutes
  const canDelete = !expenseRole.isScheduled && !hasExpenses

  const handleUpdate = (val: number) => {
    setValue("expensesBudget", val)

    const updatedRoles = formData.roles.map((role) =>
      role.id === OTHER_EXPENSES_ROLE.id
        ? { ...role, estimatedMinutes: val }
        : role,
    )
    setValue("roles", updatedRoles)
  }

  const handleDelete = () => {
    if (!canDelete) return

    // Clear the form's expensesBudget field
    setValue("expensesBudget", 0)

    // Remove the role and add to deleted roles
    const newRoles = formData.roles.filter(
      (r) => r.id !== OTHER_EXPENSES_ROLE.id,
    )
    const newDeletedRoles = [...formData.deletedRoleIds, OTHER_EXPENSES_ROLE.id]
    setValue("roles", newRoles)
    setValue("deletedRoleIds", newDeletedRoles)
  }

  const deleteTooltip = canDelete
    ? "Remove budget allocation for other expenses"
    : "You cannot remove this from your budget because you already have other expenses recorded for this project."

  return (
    <ExpensesTableRow
      label="Other Expenses"
      value={value}
      canDelete={canDelete}
      deleteTooltip={deleteTooltip}
      onUpdate={handleUpdate}
      onDelete={handleDelete}
      allocationDifference={expensesAllocationDifference}
      dataTest="other-expenses"
    />
  )
}

export default OtherExpensesRow
